// extracted by mini-css-extract-plugin
module.exports = {"container":"da51a739f7--container--C7hn2","background":"da51a739f7--background--KV7Ke","image":"da51a739f7--image--xN0Ub","footnote":"da51a739f7--footnote--TDQy5"};